import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
    Chip
} from '@mui/material'
import Date from '@mui/icons-material/DateRange';
import PersonIcon from '@mui/icons-material/Person';
import View from '@mui/icons-material/RemoveRedEye';
import Moment from 'react-moment';

const ScoreCard = ({current}) => {


    return(
        <>
        <hr/>
            <List className='scorecard'>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><View/></Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Views" secondary={current.viewCont} className="rating"/>
                </ListItem>
                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><Date/></Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Created" secondary={<Moment to={current.createdDate}></Moment>} />
                    {/* <div>
                        { current.contentlist.map((item,index)=>(
                            <Chip
                                key={`${item.status+index}`}
                                item={item.status}
                                label={item.status}
                                clickable
                                color="primary"
                                className='chip'
                            />
                        ))}
                    </div> */}
                </ListItem>
                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><PersonIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText primary="Creator" secondary={current.userName} />
                </ListItem>
            </List>
           

        </>
    )
}

export default ScoreCard